// eslint-disable-next-line import/no-anonymous-default-export
export default {
  about: 'Acerca de TOP3',
  appName: '3 PRIMEROS',
  data: 'Datos',
  tasks: 'Tareas',
  'tasks.create_title': 'Crear nueva tarea',
  'task.removed': 'Se eliminó la tarea',
  logout: 'Cerrar sesión',
  password: 'Contraseña',
  email: 'Email',
  login: 'Iniciar sesión',
  loginError: 'Correo electrónico o contraseña incorrectos',
  pleaseWait: 'Por favor espera...',
  loggedOut: '¡Has salido del sistema con éxito!',
  monday: 'Lunes',
  tuesday: 'Martes',
  wednesday: 'Miércoles',
  thursday: 'Jueves',
  friday: 'Viernes',
  saturday: 'Sábado',
  sunday: 'Domingo',
  header: 'Tarea',
  type: 'Tipo',
  typeActivity: 'Actividad',
  typeBoard: 'Administración de personal',
  typeDevelopment: 'Desarrollo estratégico',
  task: 'Tarea',
  plannedResult: 'Gol',
  achievedResult: 'Resultado',
  rating: 'Clasificación',
  ratingMet: 'Satisfactorio',
  ratingNotMet: 'Insatisfactorio',
  ratingAverage: 'Promedio',
  save: 'Salvar',
  cancel: 'Cancelar',
  date: 'Fecha',
  weekday0: 'Lunes',
  weekday1: 'Martes',
  weekday2: 'Miércoles',
  weekday3: 'Jueves',
  weekday4: 'Viernes',
  weekday5: 'Sábado',
  weekday6: 'Domingo',
  week: 'Semana',
  user: 'Empleado',
  'user.filter': 'Buscar empleado ...',
  noResults: 'Extraviado',
  comments: 'Comentarios',
  delete: 'Retirar',
  confirmTaskDelete: '¿Está seguro de que desea eliminar esta tarea?',
  myTasks: 'Mis tareas',
  sessionExpired: 'Msgstr `Se ha agotado el tiempo de espera de la sesión.',
  attachFile: 'Adjuntar archivo',
  confirmCommentDelete: '¿Estas seguro de que quieres eliminar este comentario?',
  commentEmail: 'El comentario fue enviado por correo electrónico',
  required: 'Este campo es requerido',
  'comment.tooltip': 'Agregar comentario',
  'groups.title': 'Grupos',
  'group.title': 'Grupo',
  'groups.edit_title': 'Editar grupo',
  'groups.create_title': 'Crea un grupo',
  'groups.delete_title': 'Eliminar grupo',
  'groups.id': 'No.',
  'groups.name': 'Nombre',
  'groups.ownerId': 'Gerente',
  'groups.changeOwner': 'Seleccionar gestor ...',
  'groups.find': 'Buscar grupo ...',
  'group.members': 'Miembros',
  'group.guests': 'Invitados',
  'group.addMember': 'Añadir miembro',
  'group.addGuest': 'Añadir invitado',
  'group.noMembers': 'Nadie es agregado',
  'group.confirmDelete': '¿Está seguro de que desea eliminar este grupo?',
  'users.title': 'Usuarios',
  'user.title': 'Usuario',
  'user.profile': 'Mi perfil',
  'user.modify.title': 'Editar usuario',
  'users.create.tooltip': 'Crear usuario',
  'users.delete_title': 'Eliminar usuario',
  'user.created': 'Naudotojas sukurtas',
  'user.updated': 'Naudotojas pakeistas',
  'user.removed': 'Naudotojas pašalintas',
  'users.id': 'No.',
  'user.name': 'Nombre',
  'user.surname': 'Apellido',
  'user.role': 'Papel',
  'user.role.ADMIN': 'Administrador',
  'user.role.USER': 'Usuario',
  'user.role.undefined': 'Indefinido',
  'user.email': 'Email',
  'user.email.unique': 'El correo electrónico tiene que ser único',
  'user.username': 'Nombre de usuario',
  'user.username.unique': 'El nombre de usuario debe ser único',
  'user.password': 'Contraseña de usuario',
  'user.members': 'Miembro en grupos',
  'user.guests': 'Invitado en grupos',
  'user.addGroup': 'Añadir grupo',
  'user.noMembers': 'Nadie es agregado',
  'user.delete.confirm': '¿Seguro que quieres eliminar este usuario?',
  'user.language.select': 'Idioma',
  'user.language.EN': 'English',
  'user.language.ES': 'Ispano',
  'user.language.PL': 'Polskie',
  'user.language.RU': 'Русский',
  'user.language.LT': 'Lietuvių',
  'user.language.LV': 'Latviešu',
  'user.language.EE': 'Eesti',
  'user.view.edit': 'Redaguoti naudotoją',
  'user.role.select': 'Rolė',
  'user.save.tooltip': 'Išsaugoti naudotoją',
  'user.cancel.modify.tooltip': 'Atšaukti',
  'user.password.change.save.tooltip': 'Išsaugoti naują slaptažodį',
  'user.password.change.cancel.tooltip': 'Atšaukti',
  'user.view.change.password': 'Cambia la contraseña',
  'user.password.change.title': 'Cambio de contraseña',
  'user.password.old': 'Contraseña anterior',
  'user.password.new1': 'Nueva contraseña',
  'user.password.new2': 'Repita la nueva contraseña',
  'user.password.change.mismatch': 'Las contraseñas no coinciden',
  'about.title': 'Acerca de TOP3',
  'about.tagline': 'Al pulsar este botón se descargará la descripción del sistema TOP3',
  'about.action': 'Descargar',
  'about.text': 'Estaremos esperando preguntas y observaciones de nuestro sistema '
    + '<a href="mailto:pagalba@axis.lt">pagalba@axis.lt</a> .',
  'user.password.changed': 'Contraseña cambiada.',
  'user.password.change.failed': 'Error al cambiar la contraseña. '
    + 'La contraseña dada fue incorrecta.',
  dashboard: 'Grafikas',
  'dashboard.generate': 'Generuoti',
  'dashboard.saveAsImage': 'Siųstis',
  'dashboard.exportToExcel': 'Exportuoti į Excel',
  'dashboard.dataZoom': 'Priartinti',
  'dashboard.dataZoomReset': 'Gražinti praeitą vaizdą',
  'dashboard.restore': 'Atstatyti pradinį vaizdą',
  'dashboard.noData': 'Nėra duomenų',
  'dashboard.data.title': 'Grafikas',
  'dashboard.data.dateFrom': 'Laikotarpis nuo (imtinai)',
  'dashboard.data.dateTo': 'Laikotarpis iki (imtinai)',
  'dashboard.data.unit': 'Matavimo vienetas',
  'dashboard.data.unit.WEIGHT': 'Svoris, t',
  'dashboard.data.unit.VOLUME': 'Tūris, m3',
  'dashboard.data.unit.VOLUME_AT_15C': 'Tūris prie 15°C, m3',
  'dashboard.data.exportToExcel': 'Excel',
  'dashboard.data.reportdate': 'Laikas',
  'dashboard.data.official': 'Buhalterija',
  'dashboard.data.fact': 'Faktinis',
  'dashboard.data.factFrom': 'Faktinis nuo',
  'dashboard.data.factTo': 'Faktinis iki',
  'dashboard.data.factPart5': 'Talpykla5',
  'dashboard.data.factPart6': 'Talpykla6',
  'dashboard.data.diff': 'Skirtumas',
  'dashboard.data.counter': 'Skaitiklis',
  'dashboard.data.counterDiff': 'Skaitiklio skirtumas',
  // product form generic
  products: 'Produktai',
  'products.title': 'Produktai',
  'product.title': 'Produktas',
  'product.delete.confirm': 'Ar tikrai norite pašalinti produktą',
  'product.updated': 'Produktas atnaujintas',
  'product.created': 'Produktas sukurtas',
  'product.filter': 'Ieškoti produkto...',
  'product.save.tooltip': 'Išsaugoti produktą',
  'product.modify.title': 'Produktas',
  'product.cancel.modify.tooltip': 'Atšaukti redagavimą',
  'product.create.title': 'Produkto kūrimas',
  'product.cancel.create.tooltip': 'Atšaukti kūrimą',
  'product.create.tooltip': 'Kurti produktą',
  // product form specific
  'product.type': 'Produktas',
  'product.description': 'Aprašymas',
  'product.shortDescription': 'Trumpas aprašymas',
  'product.classificator': 'Klasifikatorius',
  'product.tarrifGroupCode': 'Tarifinė grupė',
  'product.materialType': 'Produkto rūšis',
  'product.name.unique': 'Produkto pavadinimas turi būti unikalus',

  // driver form generic
  drivers: 'Vairuotojai',
  'drivers.title': 'Vairuotojai',
  'driver.title': 'Vairuotojas',
  'driver.create.tooltip': 'Kurti Vairuotoją',
  'driver.updated': 'Vairuotojas atnaujintas',
  'driver.created': 'Vairuotojas sukurtas',
  'driver.removed': 'Vairuotojas pašalintas',
  'driver.filter': 'Ieškoti vairuotojo...',
  'driver.save.tooltip': 'Išsaugoti vairuotoją',
  'driver.modify.title': 'Vairuotojo redagavimas',
  'driver.create.title': 'Vairuotojo kūrimas',
  'driver.cancel.modify.tooltip': 'Atšaukti redagavimą',
  'driver.cancel.create.tooltip': 'Atšaukti kūrimą',
  'driver.delete.confirm': 'Ar tikrai norite pašalinti vairuotoją',
  // driver form specific
  'driver.fullName': 'Vairuotojo vardas pavardė',
  'driver.adrNo': 'Vairuotojo ADR numeris',
  'driver.adrDate': 'Vairuotojo ADR galiojimo data',

  // company form generic
  companies: 'Įmonės',
  'companies.title': 'Įmonės',
  'company.title': 'Įmonė',
  'company.create.tooltip': 'Kurti Įmonę',
  'company.updated': 'Įmonė atnaujinta',
  'company.created': 'Įmonė sukurta',
  'company.removed': 'Įmonė pašalinta',
  'company.filter': 'Ieškoti įmonės ...',
  'company.save.tooltip': 'Išsaugoti įmonę',
  'company.modify.title': 'Įmonės redagavimas',
  'company.create.title': 'Įmonės kūrimas',
  'company.cancel.modify.tooltip': 'Atšaukti redagavimą',
  'company.cancel.create.tooltip': 'Atšaukti kūrimą',
  'company.delete.confirm': 'Ar tikrai norite pašalinti įmonę ?',
  // company form specific
  'company.name': 'Pavadinimas',
  'company.address': 'Adresas',
  'company.vatCode': 'PVM kodas',
  'company.country': 'Valstybė',
  'company.companyCode': 'Įmonės kodas',
  'company.exciseWhNo': 'Akcizinio sandėlio Nr.',
  'company.additionalInformation': 'Papildoma informacija',
  'company.companyCode.unique': 'Įmonės kodas turi būti unikalus',
  'company.code.unique': 'Įmonės kodas turi būti unikalus',
  'country.select': 'Valstybė',
  'company.whClient': 'Sandėlio klientas',

  // tank form generic
  tanks: 'Talpyklos',
  'tanks.title': 'Talpyklos',
  'tank.create.tooltip': 'Sukurti talpyklą',
  'tank.updated': 'Talpykla atnaujinta',
  'tank.created': 'Talpykla sukurta',
  'tank.removed': 'Talpykla pašalinta',
  'tank.filter': 'Ieškoti talpyklos...',
  'tank.save.tooltip': 'Išsaugoti talpyklą',
  'tank.modify.title': 'Talpyklos redagavimas',
  'tank.create.title': 'Talpyklos kūrimas',
  'tank.cancel.modify.tooltip': 'Atšaukti redagavimą',
  'tank.cancel.create.tooltip': 'Atšaukti kūrimą',
  'tank.delete.confirm': 'Ar tikrai norite pašalinti talpyklą ?',
  // tank form specific
  'tank.name': 'Talpyklos pavadinimas',
  'tank.capacity.ltr': 'Talpa litrais (l)',
  'tank.capacity.kg': 'Talpa kilogramais (kg)',
  'tank.material': 'Produktas',
  'tank.name.unique': 'Talpyklos pavadinimas turi būti unikalus',
  'material.select': 'Produktas',

  // transport form generic
  transports: 'Transporto priemonės',
  'transports.title': 'Transporto priemonės',
  'transport.title': 'Transporto priemonė',
  'transport.create.tooltip': 'Kurti Transporto priemonę',
  'transport.updated': 'transporto priemonė atnaujinta',
  'transport.created': 'Transporto priemonė sukurta',
  'transport.removed': 'Transporto priemonė pašalinta',
  'transport.filter': 'Ieškoti transporto priemonės',
  'transport.save.tooltip': 'Saugoti transporto priemonę',
  'transport.edit.title': 'Transporto priemonės redagavimas',
  'transport.create.title': 'Transporto priemonės kūrimas',
  'transport.cancel.modify.tooltip': 'Atšaukti',
  'transport.delete.confirm': 'Ar tikrai norite pašalinti transporto priemonę',
  // transport form specific
  'transportType.select': 'Tipas',
  'transport.name.unique': 'Transporto priemonės numeris turi būti unikalus',
  'transports.description': 'Apibūdinimas',
  'transports.brand': 'Markė',
  'transports.model': 'Modelis',
  'transports.adrNo': 'ADR numeris',
  'transports.adrDate': 'ADR galiojimo data',
  'transports.segments': 'Segmentų talpos',
  'transports.segmentNo': 'Segmento Nr.',
  'transports.capacityLtr': 'Segmento talpa, l',
  'transport.segment.add': 'Pridėti segmentą',
  'transport.segment.remove': 'Pašalinti segmentą',
  'transport.identificationNo': 'Numeris',
};
